var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["price-table--feature", _vm.type] },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.html",
              modifiers: { html: true }
            }
          ],
          staticClass: "price-table--feature-text",
          attrs: { title: _vm.tooltip }
        },
        [
          _vm.tooltip
            ? _c("Icon", {
                staticClass: "mr-1 correct-icon-top-1px",
                attrs: { icon: "info" }
              })
            : _vm._e(),
          _vm._v("\n\t\t" + _vm._s(_vm.text) + "\n\t\t"),
          _vm.subText ? _c("span", [_vm._v(_vm._s(_vm.subText))]) : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.withFree
        ? _c(
            "div",
            {
              class: [
                "price-table--feature-content",
                _vm.isColoredBackground
                  ? "bg-color-purple-light"
                  : "bg-color-white"
              ]
            },
            [
              _vm.isTypeIcon
                ? [
                    _vm.freeChecked
                      ? _c("Icon", { attrs: { icon: "checkmark" } })
                      : _vm._e()
                  ]
                : _vm.isTypeContent
                ? _c("div", { staticClass: "color-purple" }, [_vm._v("-")])
                : _vm.isTypePrice
                ? [_c("Free")]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.products, function(product) {
        return _c(
          "div",
          {
            key: product.id,
            class: [
              "price-table--feature-content",
              _vm.isColoredBackground
                ? _vm.getProductBackgroundClass(product)
                : "bg-color-white"
            ]
          },
          [
            _vm.isTypeIcon
              ? [
                  _vm.isIconChecked(product)
                    ? _c("Icon", { attrs: { icon: "checkmark" } })
                    : _vm._e()
                ]
              : _vm.isTypeContent && _vm.contentProvider
              ? _c("div", { class: "color-" + _vm.getProductColor(product) }, [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.contentProvider(product)) + "\n\t\t"
                  )
                ])
              : _vm.isTypePrice
              ? _c(
                  "div",
                  { staticClass: "price-table--feature-content-price" },
                  [
                    _c("BuyButton", {
                      attrs: {
                        product: product,
                        "upgradable-items": _vm.upgradableItems,
                        "chosen-product": _vm.chosenProduct,
                        "custom-button-click-handler":
                          _vm.customButtonClickHandler
                      },
                      on: {
                        buy: function($event) {
                          return _vm.$emit("buy", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }